import React, { useState } from 'react';
import { CardFooter } from 'reactstrap';
import { Edit, Send, X, RotateCcw } from 'react-feather';
import PropTypes from 'prop-types';
import ExpertReviewModal from '../Component/ExpertReviewModal';

const CallFormFooter = ({
    callFormState,
    handleOperation,
    formData,
    isReapplicationFile = false
}) => {
    const [showExpertReviewModal, setShowExpertReviewModal] = useState(false);
    const getSubtleButtonClasses = (baseColor) => {
        return `btn border border-${baseColor}-subtle bg-${baseColor}-subtle text-${baseColor}-emphasis d-flex align-items-center ms-2`;
    };

    const handleReturnClick = () => {
        if (callFormState === 'Eksper Onay Bekleniyor') {
            handleOperation('return', { needExpertReview: true });
        } else {
            setShowExpertReviewModal(true);
        }
    };

    const handleExpertReviewConfirm = (needExpertReview) => {
        handleOperation('return', { needExpertReview });
        setShowExpertReviewModal(false);
    };

    const handleUpdateCorrections = () => {
        const needExpertReview = formData.needExpertReview;
        
        if (needExpertReview === true) {
            handleOperation('expertApproval');
        } else {
            handleOperation('managerApproval');
        }
    };

    const toggleExpertReviewModal = () => {
        setShowExpertReviewModal(!showExpertReviewModal);
    };

    return (
        <>
            {['Taslak', 'Yeni Çağrı Formu'].includes(callFormState) && (
                <CardFooter>
                    <div className="d-flex justify-content-end align-items-center w-100">
                        <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('draft')}>
                            <Edit className="me-2" />
                            Taslak Olarak Kaydet
                        </button>
                        <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('save')}>
                            <Send className="me-2" />
                            Çağrı Formu Oluştur
                        </button>
                    </div>
                </CardFooter>
            )}            
            {['Eksper Onay Bekleniyor', 'Yönetici Onay Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={handleReturnClick}>
                                <RotateCcw className="me-2" />
                                Eksik Evrak - İade
                            </button>
                            <button className={getSubtleButtonClasses('danger')} onClick={() => handleOperation('reject')}>
                                <X className="me-2" />
                                Ret
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('approve')}>
                                <Send className="me-2" />
                                Kabul
                            </button>
                        </div>
                    </CardFooter>
                    {callFormState === 'Yönetici Onay Bekleniyor' && (
                        <ExpertReviewModal
                            isOpen={showExpertReviewModal}
                            toggle={toggleExpertReviewModal}
                            onConfirm={handleExpertReviewConfirm}
                        />
                    )}
                </>
            )}
            {['Ödeme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('correction')}>
                                <RotateCcw className="me-2" />
                                Düzeltme Bekleyen
                            </button>
                            <button className={getSubtleButtonClasses('danger')} onClick={() => handleOperation('reject')}>
                                <X className="me-2" />
                                Müvekkil Ret
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('complete')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Vekalet Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('received')}>
                                <Send className="me-2" />
                                Tamamlandı
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Evrak Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('received')}>
                                <Send className="me-2" />
                                Tamamlandı
                            </button>
                        </div>
                    </CardFooter>

                </>
            )}
            {['Eksper İşlem Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')} disabled={!formData.filesToBeWorked || formData.filesToBeWorked.length === 0}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Eksper Rapor Bekleniyor', 'Yeni Eksper Rapor Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}            {['Eksper Raporu Ödeme Bekleniyor', 'Yeni Eksper Raporu Ödeme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {callFormState === 'Sigorta Başvuru Dilekçe Bekleniyor' && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            {/* Tekrar başvuru akışı tahkim detayından yönetiliyor — çağrı formundan yönlendirme gereksiz
                            {isReapplicationFile && (
                                <button className={getSubtleButtonClasses('info')} onClick={() => handleOperation('withoutExpert')}>
                                    <Send className="me-2" />
                                    Ekspersiz Süreç
                                </button>
                            )}
                            {isReapplicationFile && (
                                <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                    <Send className="me-2" />
                                    Gönder
                                </button>
                            )}
                            */}
                        </div>
                    </CardFooter>
                </>
            )}
            {callFormState === 'İcra Sürecine Yönlendirildi' && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {callFormState === 'Yeni Sigorta Başvuru Dilekçe Bekleniyor' && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {callFormState === 'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor' && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Yeni Eksper İşlem Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')} disabled={!formData.filesToBeWorked || formData.filesToBeWorked.length === 0}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}            
            {['Düzeltme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('success')} onClick={handleUpdateCorrections}>
                                <Send className="me-2" />
                                Düzeltmeleri Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Tüm Form'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('save')}>
                                <Send className="me-2" />
                                Güncelle
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
        </>
    );
};

CallFormFooter.propTypes = {
    callFormState: PropTypes.string.isRequired,
    handleOperation: PropTypes.func.isRequired,
    formData: PropTypes.object.isRequired,
    isReapplicationFile: PropTypes.bool,
};

export default CallFormFooter;
